export class ClientFilesModel {
    FileId: number;
    client_no: number;
    id: number;
    FilePath: string;
    FileType: string;
    DateAdded: string;
    CreatedBy: number;
    username: string = '';
    image_bidata: any = null; // using 'any' as TypeScript does not have a 'byte[]' type

    constructor(
        FileId: number,
        client_no: number,
        id: number,
        FilePath: string,
        FileType: string,
        DateAdded: string,
        CreatedBy: number,
        username: string,
        image_bidata: any = null
    ) {
        this.FileId = FileId;
        this.client_no = client_no;
        this.id = id;
        this.FilePath = FilePath;
        this.FileType = FileType;
        this.DateAdded = DateAdded;
        this.CreatedBy = CreatedBy;
        this.username = username;
        this.image_bidata = image_bidata;
    }
}
